@if (logoImageNavItemConfig.imgSrc) {
  <img
    class="img-fluid"
    [src]="logoImageNavItemConfig.imgSrc"
    [alt]="logoImageNavItemConfig.imgAlt | translate"
    />
}
